import type { PathAttributes } from './types';

export default (obj: unknown): obj is PathAttributes =>
    !!(obj && typeof obj === 'object' && 'provider' in obj);
